import { post } from './http'

const baseUrl = '/api/meas/admin/resource/teacher'

// 获取老师列表
export const getTeacherList = data => post(`${baseUrl}/getTeacherList`, data)

// 获取老师详情
export const getTeacherDetails = data => post(`${baseUrl}/getTeacherDetails`, data)

// 新增修改老师
export const saveTeacher = data => post(`${baseUrl}/saveTeacher`, data)

// 删除老师
export const updateTeacherStatus = data => post(`${baseUrl}/updateTeacherStatus`, data)